import React, { useContext } from 'react';
import { Row, Col, Input, Select, Radio } from "antd";
import { AppContext } from '../../../util/context';
import { observationCategories, newDepartments } from '../../../util/details';
import { getSorted, locations } from '../../../util/details';

const {Option} = Select;

export const GeneralInformationDetails = ({hazardCard, setHazardCard, setSelectedCategoryDetails, selectedCategoryDetails, isRep}) => {
    const {
        StyledDiv,
    } = useContext(AppContext);

    return (
        <>
            <Row
                style={{
                    marginTop: "15px"
                }}
                gutter={[16, 16]}
            >
                {isRep && <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label className="inputTextLabel"><StyledDiv >Employee Type</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.employee}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>}

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label className="inputTextLabel"><StyledDiv >Employee Name</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.employee === 'anonymous' ? 'Anonymous' : hazardCard.employeeName}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Business Unit</StyledDiv></label>
                    {!isRep && <Input
                        defaultValue={hazardCard.employee === 'anonymous' && !isRep ? 'Anonymous' : hazardCard.businessUnit}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />}

                    {isRep && <Select style={{width: "100%", marginTop: "8px", height: "40px"}}
                        onChange={(value) => {
                            setHazardCard(prevState => ({ ...prevState, businessUnit: value, updateHazardRequired: true }));
                            
                        }}
                        value={hazardCard.businessUnit}
                        disabled={false}
                        className={"inputText"}
                    >   
                        {getSorted(newDepartments).map((department, index) => (
                            <Option key={index} value={department.value} className="newInputText">{department.name}</Option>
                        ))}
                    </Select>}
                </Col>

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Date Observed</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.dateObserved}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>
            </Row>

            <Row
                gutter={[16, 30]}
                style={{
                    marginTop: "30px"
                }}
            >
                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Time Observed</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.timeObserved}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Country</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.country}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>

                {hazardCard.country === 'Other' && <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Other Country</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.otherCountry}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>}

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Location Type</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.locationType}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>

                {hazardCard.locationType === 'External' && <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">External Location Type</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.externalLocationType}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>}

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    {!isRep && <>
                        <label><StyledDiv className="inputTextLabel">Location</StyledDiv></label>
                        <Input
                            defaultValue={hazardCard.location}
                            disabled={true}
                            style={{marginTop: "8px", height: "40px"}}
                            className="inputText"
                        />
                    </>}

                    {isRep && <>
                        <label><StyledDiv className="inputTextLabel">Location</StyledDiv></label>
                        {hazardCard.locationType === "Internal" && <>
                            <Select placeholder="Select location" style={{width: "100%", marginTop: "8px", height: "40px"}}
                                onChange={(value) => {
                                    setHazardCard(prevState => ({ ...prevState, location: value, updateHazardRequired: true }));
                                }}
                                showSearch
                                value={hazardCard.location}
                                className="inputText"
                            >
                                {getSorted(locations).map((location, index) => (
                                    <Option key={index} value={location.value} className="newInputText">{location.name}</Option>
                                ))}
                            </Select>
                        </>}

                        {hazardCard.locationType === "External" && <>
                            <Input
                                defaultValue={hazardCard.location}
                                onChange={(e) => {
                                    setHazardCard(prevState => ({ ...prevState, location: e.target.value, updateHazardRequired: true }));
                                }}
                                disabled={false}
                                style={{marginTop: "8px", height: "40px"}}
                                className="inputText"
                            />
                        </>}
                    </>}
                </Col>

                {hazardCard.locationType === 'External' && <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">External Customer</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.externalCustomer}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    />
                </Col>}

                <Col
                    xl={{span: 8}}
                    lg={{span: 8}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    {/* <label><StyledDiv className="inputTextLabel">Observation Type</StyledDiv></label>
                    <Input
                        defaultValue={hazardCard.observationType}
                        disabled={true}
                        style={{marginTop: "8px", height: "40px"}}
                        className="inputText"
                    /> */}
                    <label><StyledDiv className="newInputTextLabel"><span style={{color: "red"}}>*</span> Observation Type</StyledDiv></label>
                    <Radio.Group 
                        disabled={!isRep}
                        value={hazardCard.observationType}
                        onChange={(e) => {
                            setHazardCard({...hazardCard, observationType: e.target.value, updateHazardRequired: true});
                        }}
                        style={{
                            marginTop: "10px"
                        }}
                    >
                        
                        <StyledDiv>
                            <Radio value="Safe Act" className="newInputText">Safe Act</Radio>
                            <Radio value="Unsafe Act" className="newInputText">Unsafe Act</Radio>
                            <Radio value="Unsafe Condition" className="newInputText">Unsafe Condition</Radio>
                        </StyledDiv>
                    </Radio.Group>
                </Col>

                
            </Row>

            <Row
                gutter={[16, 16]}
                style={{
                    marginTop: "30px"
                }}
            >
                <Col
                    xl={{span: 24}}
                    lg={{span: 24}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label><StyledDiv className="inputTextLabel">Observation Description</StyledDiv></label>
                    <Input.TextArea 
                        defaultValue={hazardCard.observationDescription}
                        disabled={!isRep}
                        onChange={(e) => {
                            setHazardCard({...hazardCard, observationDescription: e.target.value, updateHazardRequired: true});
                        }}
                        className="inputText"
                        style={{
                            resize: "none",
                            height: "180px",
                            marginTop: "8px"
                        }}
                    />
                    
                </Col>

            </Row>


            {isRep && <Row
                gutter={[16, 16]}
                style={{
                    marginTop: "30px"
                }}
            >
                <Col
                    xl={{span: 24}}
                    lg={{span: 24}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                >
                    <label>
                        <StyledDiv className="inputTextLabel">
                            Observation Category
                            <span style={{ color: 'red', fontSize: '12px', marginLeft: '8px', display: 'inline-block' }}>
                                (Category must be selected to close card. Save changes using Save button or by closing card)
                            </span>
                        </StyledDiv>
                    </label>
                    <Select defaultValue={hazardCard.observationCategory} placeholder="Select observation category" style={{width: "100%", marginTop: "8px", height: "40px"}}
                        onChange={(value) => {
                            setHazardCard({...hazardCard, observationCategory: value, updateHazardRequired: true});
                            const selectedCategory = observationCategories.find(cat => cat.value === value);
                            setSelectedCategoryDetails(selectedCategory);
                        }}
                        showSearch
                        value={hazardCard.observationCategory}
                        className={"inputText"}
                    >
                        {getSorted(observationCategories).map((data, index) => (
                            <Option key={index} value={data.value} className="newInputText"><span style={{fontWeight: "bold"}}>{data.name}</span> - {data.description}</Option>
                        ))}
                    </Select>
                    {selectedCategoryDetails && (
                        <StyledDiv className="observationCategoryHelper" style={{marginTop: "18px", fontSize: "13px", marginBottom: "16px", paddingLeft: "10px"}}>
                            
                            <strong>{selectedCategoryDetails.name}</strong>
                            <div style={{marginTop: "4px", fontSize: "12px", fontStyle: "italic"}}>
                                {selectedCategoryDetails.description}
                            </div>
                        </StyledDiv>
                    )}
                </Col>

            </Row>}
        </>
    )
}
